import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService";
import { ConsolidatedWorker } from "./@types";

const fetch = async (cwid: string): Promise<ConsolidatedWorker> => {
  const { data } = await apiInputService.get("/consolidatedWorkers/" + cwid);

  return data as ConsolidatedWorker;
};

export const useConsolidatedWorkerByCWID = (cwid: string, options?: any) => {
  const { subscription } = useSubscription();

  return useQuery(
    ["consolidatedWorkers", subscription?.subscriptionId, cwid],
    () => fetch(cwid),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      ...options,
    }
  );
};
